/** Permissões da Área do PCP (catálogo: `permissoes/catalogo.py`, ADR-0087). */
export const PERM_VER = "area_pcp:view";
export const PERM_EXECUTAR = "area_pcp:executar";
export const PERM_EDITAR = "area_pcp:editar";
